import { restApi } from '../../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../../lib/loopback'
import { createQueryString } from '../../../../utils/Repository'

const queryTransform = {
  ...paginate
}

const validacoesCnhRepository = createRepository({
  path: 'validacoes-cnh',
  restApi,
  queryTransform: {
    ...paginate
  }
})

validacoesCnhRepository.manualFetch = ({
  solicitacaoId,
  cpf,
  numRegistro,
  numSeguranca,
  nome,
  nomeMae,
  dataValidade,
  dataEmissao,
  categoria
}) =>
  restApi.post(`/validacoes-cnh/manual-fetch/${solicitacaoId}`, {
    cpf,
    numRegistro,
    numSeguranca,
    nome,
    nomeMae,
    dataValidade,
    dataEmissao,
    categoria
  })

validacoesCnhRepository.list = ({ query, paginate, options } = {}) => {
  const queryString = createQueryString(query, paginate, queryTransform)
  return restApi.get('/validacoes-cnh' + queryString, {}, options)
}

export default validacoesCnhRepository
